import http from '../../../utils/http';
import security from '../../../utils/security';
import moment from 'moment'
import {
  REPORT_SALE_ERROR,
  REPORT_SALE_LOADING,
  REPORT_SALE_RESET,
  REPORT_SALE_SUCCESS,
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
};

function error(error) {
  return {type: REPORT_SALE_ERROR, error};
}

function loading(loading) {
  return {type: REPORT_SALE_LOADING, loading};
}

function success(items) {
  return {type: REPORT_SALE_SUCCESS, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
};

const actions = {
  getItems({ commit }, {currency, from, to}) {
    commit(loading(true));
    commit(error(null));
    to =  moment(to).format('YYYY-MM-DD')
    from =  moment(from).format('YYYY-MM-DD')
    return http.fetch('/reports/sale/' + currency.id + '?from=' + from +'&to=' + to)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  }
};

const mutations = {
  [REPORT_SALE_ERROR] (state, payload) {
    state.error = payload.error;
  },
  [REPORT_SALE_LOADING] (state, payload) {
    state.loading = payload.loading;
  },
  [REPORT_SALE_SUCCESS] (state, payload) {
    state.items = payload.items;
  },
  [REPORT_SALE_RESET] (state) {
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/report/sales.js